export const movies = {
  Programming: [
    {
      movieName: "Social Network",
      rating: 3
    },
    {
      movieName: "The internship",
      rating: 4
    },
    {
      movieName: "Tron",
      rating: 5
    }
  ],
  Action: [
    {
      movieName: "Wonder woman",
      rating: 3
    },
    {
      movieName: "Angel has fallen",
      rating: 4
    },
    {
      movieName: "Aquaman",
      rating: 2
    }
  ],
  Adventure: [
    {
      movieName: "Ready player one",
      rating: 4
    },
    {
      movieName: "Do little",
      rating: 3
    },
    {
      movieName: "Max",
      rating: 4
    }
  ]
};
